module.exports = __webpack_public_path__ + "img/iconPlusBlue36.4dc0d574.svg";